import { Modal, PersonalizedQuotesElementAccordion } from "@covertree/ui";
import { CoveredOptionName } from "@covertree/new-business-graphql";

interface Props {
  open: boolean;
  covered: CoveredOptionName[];
  notCovered: CoveredOptionName[];
  onClose: () => void;
}

export function PersonalizedQuotesWhatsCoveredModal({
  open,
  covered,
  notCovered,
  onClose,
}: Props) {
  return (
    <Modal title="Coverage Details" open={open} onClose={onClose}>
      <PersonalizedQuotesElementAccordion
        title="What's covered?"
        items={covered}
        dataTestId="whats-covered"
        isCovered
      />
      <PersonalizedQuotesElementAccordion
        title="What's not covered?"
        items={notCovered}
        dataTestId="whats-not-covered"
        isCovered={false}
      />
    </Modal>
  );
}
